import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './bucketlist.json';

const BucketList = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            level="B2"
            title="Bucket List"
            description="Talk about ambitions, dreams, travel plans and things you want to accomplish before it's too late."
            image="/Images/bucket.webp"
            seoTitle="Free English Lesson Plans: Bucket List"
            seoDescription="Life goals, travel dreams, and future aspirations vocabulary. B2 level grammar, vocabulary, and speaking exercises."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default BucketList;


